// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"258":"72c7d5e6","717":"cde0f6f9"}[chunkId] + ".chunk.css";
};